/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:54
 */
import AssetColumn from './AssetColumn';
import Gravity from '../utils/Gravity';
import {imageRules} from '../helpers/validation_helper';

class ImageColumn extends AssetColumn {
  constructor(params) {
    params.fileRules = params.fileRules || imageRules();
    params.type = 'image';
    super(params);
    this.init();
    this.bindListeners();
    this.dontCropSwitch = this.$root.find('.js-dont-crop').first();

    const $gravity = this.$root.find('.js-gravity').first();
    if ($gravity.length) {
      this.gravity = new Gravity($gravity, {
        width: this.width,
        height: this.height,
        dontCrop: this.dontCropSwitch.is(':checked'),
        gravity: this.$root
          .find('.js-gravity-value')
          .first()
          .val(),
      });
    }

    const $width = $(this.$root.find('.js-width'));
    const $height = $(this.$root.find('.js-height'));

    if ($width.length && $height.length) {
      this.width = $(this.$root.find('.js-width')).val();
      this.height = $(this.$root.find('.js-height')).val();
    }
  }

  get width() {
    return this._width;
  }

  set width(width) {
    if (width === '' || typeof width === typeof undefined) {
      this._width = undefined;
    } else {
      this._width = parseInt(width);
    }
    this.gravity.width = this._width;
    this.updateDontCropState();
  }

  get height() {
    return this._height;
  }

  set height(height) {
    if (height === '' || typeof height === typeof undefined) {
      this._height = undefined;
    } else {
      this._height = parseInt(height);
    }
    this.gravity.height = this._height;
    this.updateDontCropState();
  }

  bindListeners() {
    super.bindListeners();
    this.$root.on('change', '.js-column-action-show-related', (ev) => {
      return this.lShowRelatedChanged(ev);
    });
    this.$root.on('input', '.js-width', (ev) => this.lWidthChanged(ev));
    this.$root.on('input', '.js-height', (ev) => this.lHeightChanged(ev));
    this.$root.on('change', '.js-dont-crop', (ev) => this.lDontCropChanged(ev));
  }

  lDropzoneChanged({files}) {
    super.lDropzoneChanged({files})
    this.setSettingsButtonState(true);
  }

  lDropzoneCanceled() {
    super.lDropzoneCanceled();
    this.restore();
  }

  updateDownloadButtonState(file) {
    const $currentImage = this.$root.find('.js-preview-image').first();
    const storedUrl = $currentImage.data('stored-url');
    this.setButtonState('download', storedUrl && !file);
    return this;
  }

  lWidthChanged(ev) {
    this.width = $(ev.target).val();
  }

  lHeightChanged(ev) {
    this.height = $(ev.target).val();
  }

  lDontCropChanged(ev) {
    this.gravity.dontCrop = $(ev.target).is(':checked');
  }

  restore() {
    this.setSettingsButtonState(false);
  }

  updateDontCropState() {
    this.setDontCropState(
      typeof this.width !== typeof undefined &&
        typeof this.height !== typeof undefined
    );
  }

  setDontCropState(state) {
    if (state) {
      this.dontCropSwitch.prop('disabled', false);
    } else {
      this.dontCropSwitch.prop('disabled', true);
    }
  }

  setSettingsButtonState(state) {
    const $button = this.$root.find('.js-btn-settings').first();
    if (state && $button.hasClass('disabled')) {
      $button.removeClass('disabled');
    } else {
      $button.addClass('disabled');
    }
    return this;
  }

  lShowRelatedChanged(ev) {
    const $elt = $(ev.target);
    const $formGroup = $elt.parents('.js-form-group').first();
    const $relatedColumns = $(
      '[data-related-to="' + $formGroup.data('column-id') + '"]'
    );
    const $layoutElement = $formGroup.parents('[data-col-count]').first();
    const colCount = $layoutElement.data('col-count');
    const groupedColCount = $layoutElement.data('grouped-col-count');

    if ($relatedColumns.length) {
      if ($elt.is(':checked')) {
        if ($layoutElement.hasClass('col-md-' + groupedColCount)) {
          $layoutElement.removeClass('col-md-' + groupedColCount);
        }

        if (!$layoutElement.hasClass('col-md-' + colCount)) {
          $layoutElement.addClass('col-md-' + colCount);
        }

        for (let i = 0; i < $relatedColumns.length; i++) {
          let $relatedColumn = $($relatedColumns[i]);
          let $layoutElement = $relatedColumn
            .parents('[data-col-count]')
            .first();

          if ($layoutElement.hasClass('d-none')) {
            $layoutElement.removeClass('d-none');
          }
        }
      } else {
        if ($layoutElement.hasClass('col-md-' + colCount)) {
          $layoutElement.removeClass('col-md-' + colCount);
        }

        if (!$layoutElement.hasClass('col-md-' + groupedColCount)) {
          $layoutElement.addClass('col-md-' + groupedColCount);
        }

        for (let i = 0; i < $relatedColumns.length; i++) {
          let $relatedColumn = $($relatedColumns[i]);
          let $layoutElement = $relatedColumn
            .parents('[data-col-count]')
            .first();

          if (!$layoutElement.hasClass('d-none')) {
            $layoutElement.addClass('d-none');
          }
        }
      }
    }
  }
}

export default ImageColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/ImageColumn.js